import React from "react";
import ContractDropdown from "containers/ContractDropdown";
import ModuleBreadcrumbs from "components/ModuleBreadcrumbs";
import { Title } from "@skyportal/ui-kit";

import styles from "./styles.module.css";

export interface PageHeaderProps {
  title: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title }) => {
  return (
    <header className={styles.root}>
      <div className={styles.header}>
        <ModuleBreadcrumbs />
        <Title level={2}>{title}</Title>
      </div>
      <div className={styles.subtitleBlock}>
        <ContractDropdown className={styles.contractDropdown} />
      </div>
    </header>
  );
};

export default PageHeader;
